import type { Document } from '@/features/library/types/document'

/**
 * Une as duas fontes de documentos da Biblioteca.
 *
 * O payload global (`/gamification/data`) é cacheado e não autenticado, então
 * só carrega documentos SEM regra de desbloqueio. Os COM regra chegam pelo
 * payload por usuário (`/gamification/progress`), já avaliados para este aluno —
 * quem não satisfaz a regra simplesmente não os recebe.
 *
 * Ler apenas a fonte global faria os documentos restritos sumirem para todo
 * mundo, inclusive para quem tem acesso a eles.
 *
 * A dedupe por id é defensiva: as duas listas são disjuntas por construção no
 * backend, mas uma regressão lá não pode virar card duplicado aqui. A cópia por
 * usuário vence, por ser a que foi avaliada com o aluno em mãos.
 */
export function mergeLibraryDocuments(
  globalDocuments: Document[],
  gatedDocuments: Document[] | undefined
): Document[] {
  const gated = gatedDocuments ?? []
  const gatedIds = new Set(gated.map(document => document.id))

  return [
    ...gated,
    ...globalDocuments.filter(document => !gatedIds.has(document.id))
  ]
}
